// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"51f867e3","52":"51f867e3","120":"a0ddb005","359":"f238b9d4","421":"0ed2d6b1","461":"26126809","477":"3362456a","701":"81c086f1","840":"0a394ffc","925":"7d209919"}[chunkId] + ".chunk.css";
};